import React from 'react';
import { useMediaQuery } from '@mui/material';
import { SlidersHorizontal } from 'lucide-react';

// Step "Avanzado"
const Step4Icon = ({ color }) => {
    const matches = useMediaQuery('(min-width:600px)');
    return <SlidersHorizontal color={color} size={matches ? 25 : 20} strokeWidth={2.1} />;
};

export default Step4Icon;
